import { axios } from '@/services/axios';

/**
 * Submit number blocks to Operator Connect for create-order wholesalers.
 *
 * @param {object} formData - Header fields + Usage + items payload
 */
export async function postNumberBlocksToOc(formData) {
    return await axios.post('/numberBlocksToOc', formData);
}
